
import { GalleryImage } from "./types";
import { galleryImages } from "./data/index";

// A smaller selection of gallery images for the home page
export const homeGalleryImages: GalleryImage[] = [
  {
    id: "home-1",
    src: "/lovable-uploads/hinged_secondary_glazing.jpg",
    alt: "Noise reduction secondary glazing installed in a Victorian London townhouse",
    title: "Victorian Property Glazing",
    description: "Noise reduction secondary glazing installed in a Victorian townhouse",
    category: "heritage"
  },
  {
    id: "home-2",
    src: "/lovable-uploads/acoustic_glazing_for_windows.png",
    alt: "Acoustic secondary glazing for stairwell windows reducing noise by up to 80%",
    title: "Sound Insulation",
    description: "Acoustic secondary glazing for stairwell windows",
    category: "noise-reduction"
  },
  {
    id: "home-3",
    src: "/lovable-uploads/living_room_secondary_glazing.png",
    alt: "Energy-efficient secondary glazing in a commercial office building in London",
    title: "Office Installation",
    description: "Energy-efficient secondary glazing in a commercial building",
    category: "commercial"
  },
  {
    id: "home-4",
    src: "/lovable-uploads/windows_with_secondary_glazing.jpg",
    alt: "Thermal insulation secondary glazing improving energy efficiency in a period property",
    title: "Thermal Solution",
    description: "Secondary glazing for improved thermal efficiency",
    category: "thermal-insulation"
  }
];

// Re-export galleryImages for consistency
export { galleryImages };
